import React from 'react';
import { FormattedMessage } from 'react-intl';

import ImportedMediaCard from './ImportedMediaCard';
import { ImportedFileList, NoImportedFile } from './UI';

/**
 * @typedef {{
 *   medias: import('modules/mediaLibrary/types').UploadModalMedia[],
 *   onUpdate?: (id: string) => void,
 *   onDelete: (id: string) => void,
 *   mediasErrors?: Record<string, React.ReactNode>
 * }} ImportedMediaListProps
*/
/** @type {React.FC<ImportedMediaListProps>} */
const ImportedMediaList = ({ medias, onUpdate, onDelete, mediasErrors }) => {
  const hasMedia = medias.length > 0;
  return (
    <>
      {hasMedia && (
        <ImportedFileList>
          {medias.map((media) => (
            <ImportedMediaCard key={media.id} media={media} error={mediasErrors?.[media.id]} onUpdate={onUpdate} onDelete={onDelete} />
          ))}
        </ImportedFileList>
      )}
      {!hasMedia && (
        <NoImportedFile>
          <FormattedMessage id="mediaLibrary.noFileSelected" defaultMessage="No files selected" />
        </NoImportedFile>
      )}
    </>
  );
};

export default ImportedMediaList;
